




































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import store from "@/store";
import UserRoleSelect from "@/components/User/RoleSelect.vue";

@Component({ components: { UserRoleSelect } })
export default class Home extends Vue {
  private user = {
    email: "",
    password: "",
  };

  submit() {
    store.dispatch("login", this.user).then(
      (user) => {
        window.location.reload();
      },
      (err) => {}
    );
  }

  requestAccess() {
    this.$router.push({ name: "new_request" });
  }
}
